import React from 'react';
import Header from '../components/common/Header/Header';
import Footer from '../components/common/Footer/Footer';

const Register = () => {
  return (
    <div>
      <Header />
      <div style={{ padding: '100px 20px', textAlign: 'center' }}>
        <h1>Register</h1>
        <p>This page is under construction.</p>
      </div>
      <Footer />
    </div>
  );
};

export default Register;